import styled from 'styled-components';

import { breakpoints, Col, RadioButton, SkeletonElement } from '@notino/react-styleguide-v20';

const BaseCol = styled(Col)`
  display: flex;
  padding: 0;
  align-items: center;
`;

export const StyledDescriptionSkeleton = styled(SkeletonElement)`
  height: 1rem;

  @media (min-width: ${breakpoints.md}) {
    width: 17.5rem;
  }
`;

export const StyledOptionTitleSkeleton = styled(StyledDescriptionSkeleton)`
  width: 13.5rem;
  margin-bottom: 0.5rem;
`;

export const StyledPriceColumn = styled(BaseCol)`
  justify-content: flex-end;
  margin-left: 1.3rem;
  vertical-align: top;
`;

export const StyledDropdownItemSkeleton = styled.div`
  display: flex;
`;

export const StyledRadioButton = styled(RadioButton)`
  font-weight: 400;
`;
